import styled from "vue-styled-components";

const ConfigurationMethodsContainer = styled.section`
& .grid-columns {
    grid-template-columns: repeat(3, 1fr);
}
    & .btn {
        & .material-icons {
            font-size: 1em;
        }
        background-color: #CCCCCC;
        width: 30px;
        height: 30px;
        padding: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #FFFFFF;
        &.primary {
            background-color: #2962ff;
        }
        &.danger {
            background-color: #f62d51;
        }
        &:hover{
            background-color: #000000;
        }
    }
`;

export default ConfigurationMethodsContainer;

export const ModalAddComponent = styled.div`
    position: relative;
    padding: 15px;
    & .title {
        font-size: 1.8em;
    }

    & .btn-close {
        right: 15px;
    }

    & .options-container {
        display: flex;
        & .b-table {
            width: 100%;
        }
    }
`;